var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c("Heading", {
        attrs: { title: _vm.$t("partners"), routeName: "homepage" },
      }),
      _vm._m(0),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "container mt-5 text-center" }, [
      _c("a", { attrs: { href: "http://www.untrr.ro/" } }, [
        _vm._v("www.untrr.ro"),
      ]),
      _c("br"),
      _c("a", { attrs: { href: "http://www.tachoweb.ro/" } }, [
        _vm._v("www.tachoweb.ro"),
      ]),
      _c("br"),
      _c("a", { attrs: { href: "http://www.transmag.ro/" } }, [
        _vm._v("www.transmag.ro"),
      ]),
      _c("br"),
      _c("a", { attrs: { href: "http://www.loimacron.eu/" } }, [
        _vm._v("www.loimacron.eu"),
      ]),
      _c("br"),
      _c("a", { attrs: { href: "http://www.t-times.ro/" } }, [
        _vm._v("www.t-times.ro"),
      ]),
      _c("br"),
      _c("a", { attrs: { href: "http://www.untrrplanner.ro/" } }, [
        _vm._v("www.untrrplanner.ro"),
      ]),
      _c("br"),
      _c("a", { attrs: { href: "http://www.grsp.ro/" } }, [
        _vm._v("www.grsp.ro"),
      ]),
      _c("br"),
      _c("a", { attrs: { href: "http://www.educatierutiera.ro/" } }, [
        _vm._v("www.educatierutiera.ro"),
      ]),
      _c("br"),
      _c("a", { attrs: { href: "http://lutz.untrr.ro/" } }, [
        _vm._v("lutz.untrr.ro"),
      ]),
      _c("br"),
      _c("a", { attrs: { href: "http://cmr.untrr.ro//" } }, [
        _vm._v("cmr.untrr.ro"),
      ]),
      _c("br"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }